export default __webpack_public_path__ + "static/media/slider_image_02-xs@2x.e028b26d.jpg";